import { TFunction } from 'i18next';

export const northernIrelandTitles = (t: TFunction): Record<string, string> => {
  return {
    agreedExtensionStats: t('agreed_extensions', 'Breakdown of Agreed Extensions'),
    averageDaysTakenToRespondToEiaConsultations: t(
      'average_days_taken_to_respond_to_eia_consultations',
      'Average number of days taken to respond to EIA consultations'
    ),
    lateResponseStatItems: t('late_responses', 'Late Responses (statutory consultations)'),
    nonStatutoryTimelinessResponseStats: t(
      'response_timeliness_non_statutory',
      'Timeliness of responses (non-statutory consultations)'
    ),
    outstandingResponseStats: t(
      'number_of_outstanding_responses',
      'Number of outstanding responses'
    ),
    statutoryTimeframeExceededStats: t(
      'timeframe_exceeded_statutory',
      'Statutory Timeframe Exceeded – Breakdown'
    ),
    statutoryTimelinessResponseStats: t(
      'response_timeliness_statutory',
      'Timeliness of Consultation Responses (statutory consultations)'
    ),
    totalEiaConsultationsReceived: t(
      'total_eia_consultations_received',
      'Total number of EIA consultations received'
    ),
  };
};
